<template>
  <div
    class="panel-section-header text-panel-section-header mt-2 d-flex pointer align-items-center justify-content-between"
    v-on:click="toggleValue"
  >
    <div class="flex-column">
      {{ title }}
      <img
        v-if="showPremium"
        class="ml-1 mr-2 flex-column border-radius premium-logo-design"
        height="50"
        srcset="/images/PremiumFavicon.png"
        alt=""
      />
    </div>
    <div class="backgroundButton flex-column">
      <font-awesome-icon
        :icon="value ? ['fas', 'chevron-up'] : ['fas', 'chevron-down']"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditPollSection',

  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    showPremium: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    toggleValue() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 32px;
  margin-bottom: 8px;
  margin-top: 0px;
  line-height: 20px;
  margin-left: -16px;
  margin-right: -16px;
}
</style>
